module.exports = __webpack_public_path__ + "img/IMG_9000_L_Foamcore.c12c9b8a.jpg";